import React from 'react';
import PropTypes from 'prop-types';

import { Nav, ButtonBar } from 'C4';

const Header = ({ pathname }) => (
  <div className="header">
    {pathname.length > 7 && <Nav pathname={pathname} />}
    {pathname.length < 7 && <ButtonBar className="buttonBar" />}
  </div>
);

export default Header;

Header.propTypes = {
  pathname: PropTypes.string.isRequired,
};
